import { render, staticRenderFns } from "./newsPreviewComponent.vue?vue&type=template&id=2629c1a3&"
import script from "./newsPreviewComponent.vue?vue&type=script&lang=ts&"
export * from "./newsPreviewComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports